"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataInjector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const csr_1 = require("./csr");
const ssr_1 = require("./ssr");
const DataInjector = (props) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(csr_1.CSRDataInjector, { ...props }), (0, jsx_runtime_1.jsx)(ssr_1.SSRDataInjector, { ...props })] }));
};
exports.DataInjector = DataInjector;
